import * as React from 'react';
import { Switch, Route } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { VideoListView } from './Components/VideoListView';
import { VideoLibraryContextProvider } from './State';

interface IProps {
    isUserSubscribed: boolean;
    hasLicense: boolean;
}

export const VideoLibraryRoutes = ({ isUserSubscribed, hasLicense }: IProps) => (
    <VideoLibraryContextProvider>
        <DndProvider backend={HTML5Backend}>
            <Switch>
                <Route 
    render={(props) => (
      <VideoListView {...props} isUserSubscribed={isUserSubscribed} hasLicense={hasLicense}/>
    )} />
            </Switch>
        </DndProvider>
    </VideoLibraryContextProvider>
);
